import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';
import { LoginService } from '../../login/login.service';
import { ActFijoService } from '../ctb-act-fijo/act-fijo.service';
@Component({
  selector: 'app-depreciar-act-fijo',
  templateUrl: './depreciar-act-fijo.component.html',
  styleUrls: ['./depreciar-act-fijo.component.css']
})
export class DepreciarActFijoComponent implements OnInit {
  public periodo_vigente: number;
  public tipo_cierre: number;
  public ejercicios: any[] = [];
  cargado: boolean;
  items: any[] = [];
  busqueda: any = {};
  totalItems: number;
  no_accesible: boolean;
  activo: any = {
    idEmp: 0, idSuc: 0,nombre_empresa: '', del: 1, al: 1000, contable: true, fiscal: false, depreciar_todo: true, poliza_numero: null,
    depreciacion_de: 1, simular: true, fecha_depr: '', mes: 1, ejercicio: 2020, poliza_cada_activo_depr: false, poliza_sin_afectar_depr: true
  };
  rotate: any;
  @ViewChild('titulo') title: ElementRef;
  constructor(public loginService: LoginService, private service: ActFijoService) {
    this.activo.nombre_empresa = this.loginService.usuario.empresa_seleccionada.titulo;
  }

  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 48) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }
  validarPeriodoCerrado(): boolean {
    return true;
  }

  cargarDatosPeriodoActual() {
    this.service.getDatosCierre(this.loginService.empresa).subscribe(
      response => {
        this.periodo_vigente = parseInt(localStorage.getItem('periodo_seleccionado'));
        this.activo.mes = parseInt(localStorage.getItem('periodo_seleccionado')) == 13 ? 12 : parseInt(localStorage.getItem('periodo_seleccionado'));
        this.tipo_cierre = response.contenido.tipo_cierre;
        this.activo.fecha_depr = this.fechaActual();
        this.fecha_poliza();
      }
    );
  }

  fecha_poliza() {
    const dateString = this.activo.fecha_depr + 'T00:00:00'
    const d = new Date(dateString);
    let dia = d.getDate();
    let month = d.getMonth() + 1; //Months are zero based
    let year = d.getFullYear();
    if (this.activo.mes == month && this.activo.ejercicio == year) {
      this.no_accesible = false;
    } else {
      this.no_accesible = true;
    }
  }

  ngOnInit(): void {
    this.no_accesible = true;
    this.ejercicios = JSON.parse(localStorage.getItem('ejercicios'));
    this.activo.ejercicio = parseInt(localStorage.getItem('ejercicio_seleccionado'));
    this.activo.idEmp = this.loginService.empresa as number;
    this.activo.idSuc = this.loginService.sucursal as number;
    this.activo.mes = 1;
    this.cargarDatosPeriodoActual();
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }
  depreciacionDeToogle(valor: number) {
    this.activo.depreciacion_de = valor;
  }
  simularToogle(valor: boolean) {
    this.activo.simular = valor;
  }
  setFechaActual() {
    this.activo.fecha_depr = this.fechaActual();
    this.fecha_poliza();
  }
  fechaActual(): String {
    const currDate = 1;
    const currMonth =  this.activo.mes;
    const currYear =   this.activo.ejercicio;
    return currYear + '-' + ((currMonth < 10) ? '0' + currMonth : currMonth) + '-' + ((currDate < 10) ? '0' + currDate : currDate);
  }
  cargarCatalogo() {
    this.cargado = false;
    this.mostrarMensajeCarga();
    this.busqueda.criteriaSearch['emp'] = this.loginService.empresa;
    this.service.catalogo(this.busqueda).subscribe(
      response => {
        this.items = response.contenido.content;
        this.totalItems = response.contenido.totalElements;
        this.cerrarMensajeCarga();
      }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }

  eliminar(dtoDelete: any): void {
    Swal.fire({
      title: 'Eliminar',
      text: `¿Está seguro de eliminar este elemento?`,
      showCancelButton: true,
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {
        this.service.delete(dtoDelete.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire('TNK Ledger', err.error.mensaje, 'error');
        });
      }
    });
  }

  simular() {
    if (this.validarPeriodoCerrado() == false) {
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: 'El periodo seleccionado no se encuentra activo'
      });
    } else {
      this.service.getSimulacionXls(this.activo).subscribe(
        response => {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(response);
          a.download = 'simulacion';
          document.body.appendChild(a);
          a.click();
        }
      );
    }
  }


  depreciar(): void {
    if (this.validarPeriodoCerrado() == false) {
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: 'El periodo seleccionado no se encuentra activo'
      });
    } else {
      Swal.fire({
        title: '¿Está seguro de realizar la depreciación?',
        text: `Se recomienda antes de de realizar la depreciación, simular los resultados`,
        showCancelButton: true,
        confirmButtonText: 'Aceptar'
      }).then((result) => {
        if (result.value) {
          this.service.postDepreciacion(this.activo).subscribe(response => {
            Swal.fire('TNK Ledger', response.mensaje, 'success');
          }, err => {
            if (err.error.mensaje == null || '' || undefined) {
              err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
            }
            Swal.fire('TNK Ledger', err.error.mensaje, 'error');
          });
        }
      });
    }
  }
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }

  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }

  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
